import React from "react";
import DriverTrips from "./DriverTrips";

const CustomerTrips = () => {
  return <DriverTrips />;
};

export default CustomerTrips;
